import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";
import { useVisit } from "./VisitProvider";

type ProgressContextTypes = {
  currentStep: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  totalSteps: number;
  progressPercentage: number;
  lastMainPosition: number | null;
  setLastMainPosition: Dispatch<SetStateAction<number | null>>;
};

const ProgressContext = createContext<ProgressContextTypes>({
  currentStep: 0,
  setCurrentStep: () => {},
  totalSteps: 0,
  progressPercentage: 0,
  lastMainPosition: null,
  setLastMainPosition: () => {},
});

type ProgressProviderTypes = {
  children: ReactNode;
};

export const ProgressProvider: FC<ProgressProviderTypes> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [lastMainPosition, setLastMainPosition] = useState<number | null>(null);
  const intake = useVisit(
    (v) => v.questions?.filter((q) => q.question_position != null) ?? []
  );

  const totalSteps = useMemo(() => {
    return intake.length;
  }, [intake.length]);

  const progressPercentage = totalSteps ? (currentStep / totalSteps) * 100 : 0;

  return (
    <ProgressContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        totalSteps,
        progressPercentage,
        lastMainPosition,
        setLastMainPosition,
      }}
    >
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgress = () => useContext(ProgressContext);
